import React from 'react';
export const PrivacyPolicy = () => {
  return <div className="pt-20" data-id="element-3825">
      <section className="py-16 bg-secondary/5" data-id="element-3826">
        <div className="container mx-auto px-4" data-id="element-3827">
          <h1 className="text-4xl font-bold text-center text-secondary-dark mb-6" data-id="element-3828">
            Privacy Policy
          </h1>
          <p className="text-center text-secondary" data-id="element-3829">Last updated: 19|08|2025</p>
        </div>
      </section>
      <section className="py-16" data-id="element-3830">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-3831">
          <div className="prose prose-lg max-w-none" data-id="element-3832">
            <p data-id="element-3833">
              The Networking Salon ("we," "our," or "us") values your trust.
              This Privacy Policy explains how we collect, use, and protect your
              information when you engage with our website, events, and
              community.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-3834">
              1. Information We Collect
            </h2>
            <p data-id="element-3835">When you interact with The Networking Salon, we may collect:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-3836">
              <li data-id="element-3837">
                <strong data-id="element-3838">Personal Information:</strong> Name, email, phone
                number, company, role/title, and other details you share when
                registering for events, subscribing to updates, or filling out
                forms.
              </li>
              <li data-id="element-3839">
                <strong data-id="element-3840">Community Information:</strong> If you join our network,
                we may collect details you provide about your professional
                background, interests, and connections.
              </li>
              <li data-id="element-3841">
                <strong data-id="element-3842">Website Data:</strong> IP address, browser type, pages
                visited, and time spent on our site.
              </li>
              <li data-id="element-3843">
                <strong data-id="element-3844">Cookies:</strong> Small files that help us improve your
                experience and track engagement.
              </li>
            </ul>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-3845">
              2. How We Use Your Information
            </h2>
            <p data-id="element-3846">We use your information to:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-3847">
              <li data-id="element-3848">Register you for events and send confirmations/updates.</li>
              <li data-id="element-3849">
                Share relevant communications such as newsletters, networking
                opportunities, or event invitations.
              </li>
              <li data-id="element-3850">
                Improve the quality of our website, community, and events.
              </li>
              <li data-id="element-3851">
                Build stronger connections between members of our network.
              </li>
              <li data-id="element-3852">Ensure compliance with legal and security requirements.</li>
            </ul>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-3853">
              3. Sharing Your Information
            </h2>
            <p data-id="element-3854">
              We respect your privacy. Your information is never sold. We may
              only share your information with:
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-3855">
              <li data-id="element-3856">
                <strong data-id="element-3857">Event & Service Partners:</strong> Trusted providers
                (e.g., venues, ticketing, email platforms) necessary to deliver
                our services.
              </li>
              <li data-id="element-3858">
                <strong data-id="element-3859">Community Connections:</strong> With your consent, we
                may share limited professional information to foster
                introductions within our network.
              </li>
              <li data-id="element-3860">
                <strong data-id="element-3861">Legal Obligations:</strong> When required by law or to
                protect our rights and community.
              </li>
            </ul>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-3862">
              4. Cookies & Tracking
            </h2>
            <p data-id="element-3863">We use cookies to:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-3864">
              <li data-id="element-3865">Remember your preferences.</li>
              <li data-id="element-3866">Understand how people use our site.</li>
              <li data-id="element-3867">Improve our content and event promotion.</li>
            </ul>
            <p data-id="element-3868">You can manage cookies through your browser settings.</p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-3869">5. Data Retention</h2>
            <p data-id="element-3870">
              We keep your information only as long as needed to provide
              services, manage community relationships, or comply with legal
              obligations.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-3871">6. Your Rights</h2>
            <p data-id="element-3872">Depending on your location, you may have rights such as:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-3873">
              <li data-id="element-3874">Accessing or updating your information.</li>
              <li data-id="element-3875">Requesting deletion of your data.</li>
              <li data-id="element-3876">Opting out of marketing communications at any time.</li>
              <li data-id="element-3877">Restricting certain uses of your personal information.</li>
            </ul>
            <p data-id="element-3878">
              To exercise these rights, email us at:
              thenetworkingsalon@gmail.com
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-3879">7. Security</h2>
            <p data-id="element-3880">
              We use reasonable safeguards to protect your information. However,
              no online transmission is completely secure, so we encourage you
              to take care when sharing information.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-3881">
              8. Third-Party Links
            </h2>
            <p data-id="element-3882">
              The Networking Salon may link to external sites (e.g., partners,
              event platforms). We are not responsible for their privacy
              practices.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-3883">9. Policy Updates</h2>
            <p data-id="element-3884">
              We may update this Privacy Policy occasionally. Updates will be
              posted on this page with the latest revision date.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-3885">10. Contact Us</h2>
            <p data-id="element-3886">
              If you have questions about this Privacy Policy or how we handle
              your information, please reach out:
            </p>
            <p data-id="element-3887">
              📧 Email:{' '}
              <a href="mailto:info@thenetworkingsalon.live" className="text-primary hover:underline" data-id="element-3888">
                info@thenetworkingsalon.live
              </a>
            </p>
          </div>
        </div>
      </section>
    </div>;
};